import { WithChildren } from '@config';
import React from 'react';
import { IntlProvider } from 'react-intl';
import { ToastContainer } from 'react-toastify';
import { flattenMessages } from 'services/i18n/intl';
import enMessages from 'translations/en.json';

import 'assets/reset.css';
import 'global.scss';
import 'react-toastify/dist/ReactToastify.css';
import 'react-datepicker/dist/react-datepicker.css';

/* Language polyfills needed for IE11, Edge, Safari 12 & 13 support
https://github.com/formatjs/react-intl/blob/master/docs/Upgrade-Guide.md#migrate-to-using-native-intl-apis
*/
import '@formatjs/intl-pluralrules/polyfill';

import '@formatjs/intl-relativetimeformat/polyfill';
/* End of language polyfills */

import styles from './Root.module.scss';

const locales = {
  en: flattenMessages(enMessages),
};

const Root: React.FC<WithChildren> = ({ children }) => {
  return (
    <IntlProvider locale="en" messages={locales.en}>
      <div className={styles.rootContainer}>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable={false}
          pauseOnHover
        />
        {children}
      </div>
    </IntlProvider>
  );
};

export default Root;
